var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.972 46.752c.624 0 1.128.192 1.512.576.432.384.648.888.648 1.512s-.216 1.152-.648 1.584c-.384.384-.888.576-1.512.576H2.268c-.624 0-1.152-.192-1.584-.576-.384-.432-.576-.96-.576-1.584V2.76c0-.624.216-1.128.648-1.512C1.188.816 1.74.6 2.412.6c.624 0 1.152.216 1.584.648.432.384.648.888.648 1.512v43.992h23.328z",
    fill: "currentColor"
  })));
}
export default SvgL;